import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';

import DialogPanel from './DialogPanel';

const MODAL_STRING_PROMPT_FORM_NAME = 'modalStringPromptForm';
const { bool, func, number, string } = PropTypes;

class ModalStringPrompt extends Component {
  static propTypes = {
    ...formPropTypes,
    customButtonText: string,
    initialValue: string,
    isOpen: bool,
    label: string.isRequired,
    maxLength: number,
    panelTitle: string,
    onClose: func.isRequired,
    onSave: func.isRequired,
    validate: func.isRequired,
    dataTestName: string,
  };

  static defaultProps = {
    initialValue: '',
  };

  constructor() {
    super();
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.panelId = 'modal-string-prompt';
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValue !== nextProps.initialValue) {
      this.props.change('stringInput', nextProps.initialValue);
    }
  }

  isOkEnabled() {
    return this.props.valid;
  }

  handleSave(values) {
    this.props.onSave(values.stringInput);
    this.handleClose();
  }

  handleClose() {
    this.props.reset();
  }

  render() {
    const {
      customButtonText,
      isOpen,
      handleSubmit,
      label,
      maxLength,
      onClose,
      panelTitle,
      validate,
    } = this.props;

    return (
      isOpen && (
        <DialogPanel
          activePanelId={this.panelId}
          contentStyle={{ width: 400, height: 250 }}
          customButtonText={customButtonText}
          dialogFocusId="stringInput"
          hideDialogPanel={onClose}
          isOkEnabled={this.isOkEnabled}
          onClose={this.handleClose}
          onSave={handleSubmit(this.handleSave)}
          panelId={this.panelId}
          panelTitle={panelTitle}
        >
          <div
            data-test-name={
              this.props.dataTestName
                ? this.props.dataTestName
                : 'modal-string-prompt'
            }
            style={{ display: 'flex', alignItems: 'center', margin: '20px' }}
          >
            <label htmlFor="stringInput" style={{ paddingRight: 10 }}>
              {label}
            </label>
            <Field
              className="input"
              name="stringInput"
              id="stringInput"
              component="input"
              maxLength={maxLength}
              validate={validate}
              data-test-name="modal-string-prompt-input"
            />
          </div>
        </DialogPanel>
      )
    );
  }
}

const stringPromptForm = reduxForm({
  form: MODAL_STRING_PROMPT_FORM_NAME,
})(ModalStringPrompt);

export default stringPromptForm;



// WEBPACK FOOTER //
// ./src/view/App/DialogPanels/ModalStringPrompt.js